import { render, staticRenderFns } from "./memberHistory.vue?vue&type=template&id=241aeb1d&scoped=true&"
import script from "./memberHistory.vue?vue&type=script&lang=ts&"
export * from "./memberHistory.vue?vue&type=script&lang=ts&"
import style0 from "./memberHistory.vue?vue&type=style&index=0&id=241aeb1d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241aeb1d",
  null
  
)

export default component.exports